import store from '@/store';
import axios from 'axios';
import toGeoJSON from "@mapbox/togeojson/togeojson.js";

class Runner {
    constructor(id_module, id_coureur, id_live = null) {
        // Paramètres de base
        this.id = id_coureur;
        this.id_module = id_module;
        this.id_live = id_live;
        this._loadAsPcCourse = false;

        this.estimation = null;
        this.identite = null;
        this.parcours = null;
        this.passages = null;
        this.statut = null;
        this.statut_course = null;

        this.lines = [];
    }

    async fetch() {

        const base_url = store.state.base_url;
        let url = `${base_url}/runner/fetch.php?id_module=${this.id_module}&id=${this.id}&id_live=${this.id_live}`;
        if (this._loadAsPcCourse) {
            url += "&pc_course=1";
        }
        try {
            const response = await axios.get(url);
            this.set(response.data);
            return true;
        } catch (error) {
            console.error(error);
            return false;
        }
    }
    set(data) {
        for (const [key, value] of Object.entries(data)) {
            // Ne pas écraser les propriétés privées (commençant par _)
            if (!key.startsWith('_')) {
                this[key] = value;
            }
        }
    }

    setLoadAsPcCourse(loadAsPcCourse) {
        this._loadAsPcCourse = loadAsPcCourse == "1";
    }

    async buildLines() {
        if (this.parcours && this.parcours.trace && this.lines.length === 0) {
            const response = await axios.get("https://sportips.fr/live/" + this.parcours.trace);
            var geojson = toGeoJSON.gpx(new DOMParser().parseFromString(response.data, "text/xml"));
            this.lines = geojson.features[0].geometry.coordinates;
        }
    }
}

export default Runner;